import { axiosInstanceWithoutLoader } from "@/use/utilities/axios/app/axios-instance-without-loader";

/**
 * Create a new conformity document for a prescription
 * @param {string|number} prescriptionId - The prescription ID
 * @param {Object} options - Options for document creation
 * @param {string} [options.shipped_at] - Optional shipping date in ISO format, defaults to current date
 * @returns {Promise<Object>} - The created document details
 * @throws {Error} - Throws error for validation errors, conflicts, or other API errors
 */
export async function create(prescriptionId, options = {}) {
  const axios = axiosInstanceWithoutLoader().primoLab;

  try {
    const payload = {};
    
    if (options.shipped_at) {
      payload.shipped_at = options.shipped_at;
    }

    const response = await axios.post(`/conformity-documents/${prescriptionId}`, payload);
    
    return {
      document: response.data.data || response.data,
      success: true
    };
  } catch (error) {
    if (error.response?.status === 409) {
      return {
        document: null,
        success: false,
        conflict: true,
        message: error.response?.data?.message || 'La dichiarazione del fabbricante esiste già per questa prescrizione'
      };
    }
    
    if (error.response?.status === 400) {
      const errorMessages = error.response?.data?.errors || ['Errore di validazione'];
      throw new Error(errorMessages.join(', '));
    }
    
    const errorMessages = error.response?.data?.errors || ['Si è verificato un errore nella creazione del documento'];
    throw new Error(errorMessages.join(', '));
  }
}